import { render, staticRenderFns } from "./RequestList.vue?vue&type=template&id=558008e2&"
import script from "./RequestList.vue?vue&type=script&lang=ts&"
export * from "./RequestList.vue?vue&type=script&lang=ts&"
import style0 from "./RequestList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports